import { Document, Information } from '@codegouvfr/react-dsfr/picto';
import {CAMPAGNE_STATUS_STYLES, getBadgeSeverityByStatutOrganisme, ORGANISME_STATUS_STYLES} from '@common/config';
import { useOrganismeDetailsContext } from '@common/contexts';
import { BadgeSeverity } from '@common/dsfr-ui';
import { useCurrentCampagne } from '@common/hooks/campagne';
import { EtablissementProjection, useGetAllOrganismeEtablissementsQuery } from '@common/services';
import { DateUtils } from '@common/utils';
import React from 'react';
import { DashboardInformationCard } from './components/DashboardInformationCard';
import { InformationProps } from './types/information-props.type';

export const DashboardInformations = () => {
  const { id, raisonSociale, statut, nda, siren } = useOrganismeDetailsContext();
  const { campagne } = useCurrentCampagne();
  const { data: etablissements } = useGetAllOrganismeEtablissementsQuery({
    id,
    projection: EtablissementProjection.INFO,
  }, { skip: !id });

  if (!campagne) return null;

  const organismeText: string = ORGANISME_STATUS_STYLES[statut].text;
  const organismeSeverity: BadgeSeverity = getBadgeSeverityByStatutOrganisme(statut);
  const informationOrganisme: InformationProps = {
    picto: <Information fontSize={'large'} />,
    title: raisonSociale,
    statutText: organismeText,
    badgeSeverity: organismeSeverity,
    badgeNoIcon: false,
    subSection: [
      { title: 'NDA', text: nda },
      { title: 'SIREN', text: siren },
      { title: `Établissement${(etablissements?.length > 0) ? 's' : ''}`, text: `${etablissements?.length}` },
    ],
    linkText: 'Mon OFA',
    linkUrl: '/mon-ofa',
  };

  const informationCampagne: InformationProps = {
    picto: <Document fontSize={'large'} />,
    title: `Campagne ${campagne.annee}`,
    statutText: CAMPAGNE_STATUS_STYLES[campagne.statut]['text'],
    badgeSeverity: CAMPAGNE_STATUS_STYLES[campagne.statut]['badgeSeverity'],
    badgeNoIcon: true,
    subSection: [
      { title: 'Ouverture des inscriptions', text: DateUtils.formatDdMmYyyy(campagne.dateDebutInscription) },
      { title: 'Ouverture des dépôts', text: DateUtils.formatDdMmYyyy(campagne.dateOuvertureDepot) },
      { title: 'Clôture des dépôts', text: DateUtils.formatDdMmYyyy(campagne.dateClotureDepot) },
    ],
    linkText: 'Campagne',
    linkUrl: '/campagne',
  };

  return (
    <div className={'flex flex-col md:flex-row gap-6 w-full'}>
      <div className={'w-full md:w-2/5'}>
        <DashboardInformationCard {...informationOrganisme} />
      </div>
      <div className={'w-full md:w-3/5'}>
        <DashboardInformationCard {...informationCampagne} />
      </div>
    </div>
  );
};